/*
*
* (c) 2014 by MMCAGENTUR  // dar, ths, wen, peb
*
*/

// UMD PATTERN
( function(root, factory) {
    if ( typeof define === 'function' && define.amd) {
        define('mmc.libs.log',[], factory);
    } else if ( typeof exports === 'object') {
        module.exports = factory();
    } else {
        root.log = factory();
    }
}(this, function() {
// END UMD-PATTERN
    // Log Constructor
    if (!this.console || !this.console.log) {
        this.console = {
            log : function() {
            }
        };
    }
    return Function.prototype.bind.call(this.console.log, this.console);
}));

